var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33979",
    "data-name": "Group 33979",
    transform: "translate(-1020 -187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14043",
    "data-name": "Rectangle 14043",
    width: 20,
    height: 20,
    transform: "translate(1020 187)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33961",
    "data-name": "Group 33961",
    transform: "translate(811.468 -90.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M211.093,286.4h14.916",
    transform: "translate(-0.015 -1.207)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M224.044,279v2.754",
    transform: "translate(-2.127)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M215.965,279v2.754",
    transform: "translate(-0.81)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M222.079,280.579h-7.086c-2.458,0-3.993,1.369-3.993,3.886v7.574A3.636,3.636,0,0,0,214.993,296h7.079c2.466,0,3.993-1.377,3.993-3.893v-7.638C226.072,281.948,224.545,280.579,222.079,280.579Z",
    transform: "translate(0 -0.258)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarNew);
export default __webpack_public_path__ + "static/media/calendar-new.e56a2a45.svg";
export { ForwardRef as ReactComponent };